/* eslint-disable */
import Header from "components/Common/Header/Header";
import InvoiceListBody from "components/InvoiceComponents/InvoiceList/InvoiceListBody";
import React, { useEffect } from "react";

const InvoiceList = () => {
  // -------- for title ------------
  useEffect(() => {
    document.title = "Invoice";
  }, []);

  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="invoice" />

      {/* --------- body section ------------ */}
      <InvoiceListBody />
    </main>
  );
};

export default InvoiceList;
